$(document).ready(function() {

    const $iconCounter = $('.icon-counter');

    let $interval = setInterval ( function() {
    	if (parseInt($iconCounter.text()) > 0 ) {
    		$iconCounter.css({opacity: 1});
    		clearInterval($interval);
    	}

    	if ($iconCounter.length == 0) {
    		clearInterval($interval);
    	}
    }, 150);

});
